import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { ManageAccessAndResponsibleInComponents } from 'src/app/core/state/menu-tree-structure.actions';
import { ManageAccessResponsibleForm } from '../forms/manage-access-responsible.form';

@Component({
  selector: 'app-manage-access-responsible-menu-modal',
  templateUrl: './manage-access-responsible-menu-modal.component.html',
  styleUrls: ['./manage-access-responsible-menu-modal.component.scss'],
  standalone: false,
})
export class ManageAccessResponsibleMenuModalComponent implements OnInit {
  form: ManageAccessResponsibleForm;

  ngOnInit(): void {
    this.form = new ManageAccessResponsibleForm(this.data.componentId);
  }

  constructor(
    public dialogRef: MatDialogRef<ManageAccessResponsibleMenuModalComponent>,
    private store: Store,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      componentId: string;
    }
  ) {}

  save(): void {
    if (!this.form.valid) {
      return;
    }

    this.store.dispatch(new ManageAccessAndResponsibleInComponents(this.form.value));
  }
}
